var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-2",class:_vm.gridClasses},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header px-4 text-light"},[_c('h3',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_c('div',{staticClass:"card-body px-4 pb-3"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }